export default {"src":"/_next/static/media/hexagon-image-classic-solid.c357f632.svg","height":24,"width":24};